import { useEffect, useRef, useState } from "react";

/**
 * Iter 19.50 — Landing-Page-Mocks Scroll-Reveal-Hook.
 * Beobachtet ein Element via IntersectionObserver und setzt `inView=true`
 * sobald es zum ersten Mal sichtbar wird (single-shot, kein Toggle bei
 * Re-Hide → Re-Show, sonst stören die Animationen den Scroll).
 */
export function useInView({ rootMargin = "0px 0px -10% 0px", threshold = 0.2 } = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    if (typeof IntersectionObserver === "undefined") {
      setInView(true);
      return undefined;
    }
    const obs = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setInView(true);
            obs.disconnect();
            break;
          }
        }
      },
      { rootMargin, threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [rootMargin, threshold]);

  return { ref, inView };
}
